"use client";

// Fehlerzustand des Kalenders: ein Satz, ein Knopf. Die technische
// Meldung bleibt auf dem Server (Next ersetzt sie im Produktionsbau).
import { useEffect } from "react";
import { CalendarX2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/ui/empty-state";

export default function KalenderFehler({ error, retry }: { error: unknown; retry: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);
  const digest = error instanceof Error ? (error as Error & { digest?: string }).digest : undefined;

  return (
    <EmptyState
      icon={CalendarX2}
      title="Der Kalender ließ sich nicht laden"
      description={digest ? `Fehlerkennung ${digest} — bitte bei der Ansichtssache melden, wenn es bleibt.` : "Bitte noch einmal versuchen."}
      action={<Button onClick={() => retry()}>Noch einmal</Button>}
    />
  );
}
